import { motion, useReducedMotion } from "framer-motion";
import { FondoVideoAmbient } from "../../shared";
import { Banderines, Confeti, Globos } from "./Ilustraciones";

export default function Portada({ datos }) {
  const { protagonista, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 26, scale: reduce ? 1 : 0.96 },
    animate: { opacity: 1, y: 0, scale: 1 },
    transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className="ki-portada" data-testid="ki-portada">
      <Banderines />
      <Confeti />
      <div className="ki-portada-texto">
        <motion.p className="ki-portada-frase" {...entrar(0.1)}>
          {protagonista.fraseIntroductoria}
        </motion.p>
        <div className="ki-portada-fila">
          <motion.h1 className="ki-portada-nombre" data-testid="ki-nombre" {...entrar(0.25)}>
            {protagonista.nombre}
          </motion.h1>
          {protagonista.edad && (
            <motion.div className="ki-portada-edad" data-testid="ki-edad" {...entrar(0.4)}>
              <span className="ki-portada-edad-numero">{protagonista.edad}</span>
              <span className="ki-portada-edad-texto">{protagonista.textoEdad || "años"}</span>
            </motion.div>
          )}
        </div>
        <motion.p className="ki-portada-fecha" data-testid="ki-fecha" {...entrar(0.55)}>
          {evento.fechaLegible} · {evento.ciudad}
        </motion.p>
        <motion.p className="ki-portada-mensaje" {...entrar(0.68)}>
          {protagonista.mensajePortada}
        </motion.p>
        {protagonista.textoBotonEntrada && (
          <motion.a href="#ki-contenido" className="ki-boton" data-testid="ki-boton-bajar" {...entrar(0.8)}>
            {protagonista.textoBotonEntrada}
          </motion.a>
        )}
      </div>
      <motion.div className="ki-portada-visual" {...entrar(0.5)}>
        <div className="ki-portada-fotomarco">
          {datos.portadaVideo?.urlYoutube ? (
            <FondoVideoAmbient
              urlYoutube={datos.portadaVideo.urlYoutube}
              poster={datos.portadaVideo.poster || fotos.portada}
            />
          ) : (
            <img
              className="ki-portada-foto"
              src={fotos.portada}
              alt={`Fotografía de la fiesta de ${protagonista.nombre}`}
            />
          )}
        </div>
        <Globos />
      </motion.div>
    </header>
  );
}
